import * as React from 'react';

import { enumFacilitySortOption } from '@rematter/frontend-lib-api-client';
import { Checkbox, CheckboxGroup } from '@rematter/ui-web';

import { useFacilitiesQueryForFacilityGroupForm } from '../../hooks/useFacilitiesQueryForFacilityGroupForm';

export type FacilitySelectProps = {
  label?: string;
  values?: string[];
  onChange?: (values: string[]) => void;
  isRequired?: boolean;
  isDisabled?: boolean;
};

export const FacilitySelect = ({
  label,
  values = [],
  onChange,
  isRequired,
  isDisabled,
}: FacilitySelectProps) => {
  const { data } = useFacilitiesQueryForFacilityGroupForm({
    sorting: [enumFacilitySortOption.NameAsc],
    limit: 50,
  });

  const options = React.useMemo(() => data?.facilities ?? [], [data]);

  const handleSelectionChange = React.useCallback(
    (selectedValues: string[]) => {
      onChange?.(selectedValues);
    },
    [onChange],
  );

  return (
    <div className="@FacilitySelect flex flex-col gap-2">
      <CheckboxGroup
        label={label}
        value={values}
        onChange={handleSelectionChange}
        isRequired={isRequired}
        isDisabled={isDisabled}
      >
        <div className="grid max-h-60 grid-cols-3 gap-x-4 gap-y-2 overflow-auto pr-2">
          {options.map((facility) => (
            <Checkbox
              key={facility.id}
              value={facility.id}
              className="min-w-0 truncate"
            >
              {facility.facilityName}
            </Checkbox>
          ))}
        </div>
      </CheckboxGroup>
    </div>
  );
};
